import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface SmsThreadViewProps {
  thread: ConversationThread;
}

export const SmsThreadView = memo(function SmsThreadView({
  thread,
}: SmsThreadViewProps) {
  return <ChatThreadView channel="sms" thread={thread} />;
});
